<b3-drawer
  [open]="open"
  size="md"
  overlay
  (b3-close)="onDrawerClose()"
  (b3-back)="onDrawerBack()"
  (b3-request-close)="onDrawerClose()"
  (b3-request-back)="onDrawerBack()">
  <b3-drawer-header
    heading="Detalhes do Projeto"
    show-back
    back-aria-label="Fechar detalhes do projeto">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="project-details-drawer" *ngIf="!isLoading && projectData; else loadingState">
      <b3-tag
        class="project-details-drawer__status"
        size="sm"
        variant="filled"
        [icon]="statusIcon"
        [tone]="statusTone"
        [label]="statusLabel">
      </b3-tag>

      <div
        *ngIf="showRejectionReason && projectData.reasonRejection"
        class="project-details-drawer__rejection-comment">
        <div class="project-details-drawer__rejection-comment-header">
          <b3-icon name="comment" size="sm" tone="danger"></b3-icon>
          <span class="project-details-drawer__rejection-comment-label">Comentário</span>
        </div>
        <p class="project-details-drawer__rejection-comment-text">
          {{ projectData.reasonRejection }}
        </p>
      </div>

      <h2 class="project-details-drawer__section-title">ETAPA 1 - DADOS GERAIS</h2>

      <div class="project-details-drawer__field-card">
        <div class="project-details-drawer__field project-details-drawer__field--full">
          <span class="project-details-drawer__label">Nome do projeto</span>
          <span class="project-details-drawer__value">{{ projectData.projectName || '-' }}</span>
        </div>
      </div>

      <div class="project-details-drawer__fields-stack">
        <div class="project-details-drawer__field">
          <span class="project-details-drawer__label">Conta registrador</span>
          <span class="project-details-drawer__value">{{ projectData.registerCode || '-' }}</span>
        </div>
      </div>

      <div class="project-details-drawer__fields-stack">
        <div class="project-details-drawer__field-card">
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">Data de início do projeto</span>
            <span class="project-details-drawer__value">{{ projectData.projectStartDate || '-' }}</span>
          </div>
        </div>
      </div>

      <div class="project-details-drawer__field-card">
        <div class="project-details-drawer__field project-details-drawer__field--full">
          <span class="project-details-drawer__label">Atividade de linha de base</span>
          <span class="project-details-drawer__value">{{ baselineActivity }}</span>
        </div>
      </div>

      <div class="project-details-drawer__field-card">
        <div class="project-details-drawer__field project-details-drawer__field--full">
          <span class="project-details-drawer__label">Descrição</span>
          <p class="project-details-drawer__value project-details-drawer__value--description">
            {{ projectData.generalDetails || '-' }}
          </p>
        </div>
      </div>

      <div class="project-details-drawer__fields-stack">
        <div class="project-details-drawer__field-card">
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">Razão social do Desenvolvedor</span>
            <span class="project-details-drawer__value">{{ developerPrincipal?.developerName || '-' }}</span>
          </div>
        </div>

        <div class="project-details-drawer__field-card">
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">CPF/CNPJ do Desenvolvedor</span>
            <span class="project-details-drawer__value">{{ developerPrincipal?.cpfCnpj || '-' }}</span>
          </div>
        </div>

        <div class="project-details-drawer__field-card">
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">E-mail do Desenvolvedor</span>
            <span class="project-details-drawer__value">{{ developerPrincipal?.email || '-' }}</span>
          </div>
        </div>

        <div class="project-details-drawer__field-card">
          <div class="project-details-drawer__field">
            <span class="project-details-drawer__label">Telefone do Desenvolvedor</span>
            <span class="project-details-drawer__value">{{ developerPhoneLabel }}</span>
          </div>
        </div>
      </div>

      <div class="project-details-drawer__field-card">
        <div class="project-details-drawer__field project-details-drawer__field--full">
          <ng-container *ngIf="otherDevelopers.length; else emptyOtherDevelopers">
            <div class="project-details-drawer__developers-table">
              <div class="project-details-drawer__developers-row project-details-drawer__developers-row--header">
                <span class="project-details-drawer__label">Outros desenvolvedores</span>
                <span class="project-details-drawer__label">CPF/CNPJ</span>
              </div>
              <div
                *ngFor="let developer of otherDevelopers"
                class="project-details-drawer__developers-row">
                <span class="project-details-drawer__value">{{ developer.developerName || '-' }}</span>
                <span class="project-details-drawer__value">{{ developer.cpfCnpj || '-' }}</span>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyOtherDevelopers>
            <div class="project-details-drawer__developers-table">
              <div class="project-details-drawer__developers-row project-details-drawer__developers-row--header">
                <span class="project-details-drawer__label">Outros desenvolvedores</span>
                <span class="project-details-drawer__label">CPF/CNPJ</span>
              </div>
              <div class="project-details-drawer__developers-row">
                <span class="project-details-drawer__value">-</span>
                <span class="project-details-drawer__value">-</span>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <h2 class="project-details-drawer__section-title project-details-drawer__section-title--spaced">
        ETAPA 2 - PROPRIEDADES
      </h2>

      <div
        *ngFor="let property of propertyLocations; let index = index"
        class="project-details-drawer__property-block">
        <p
          *ngIf="propertyLocations.length > 1"
          class="project-details-drawer__property-index">
          Propriedade {{ index + 1 }}
        </p>

        <div class="project-details-drawer__fields-stack">
          <div class="project-details-drawer__field-card">
            <div class="project-details-drawer__field">
              <span class="project-details-drawer__label">Proprietário</span>
              <span class="project-details-drawer__value">{{ property.ownerName }}</span>
            </div>
          </div>

          <div class="project-details-drawer__field-card">
            <div class="project-details-drawer__field">
              <span class="project-details-drawer__label">CPF/CNPJ</span>
              <span class="project-details-drawer__value">{{ property.ownerDocument }}</span>
            </div>
          </div>

          <div class="project-details-drawer__field-card">
            <div class="project-details-drawer__field">
              <span class="project-details-drawer__label">Município</span>
              <span class="project-details-drawer__value">{{ property.municipality }}</span>
            </div>
          </div>

          <div class="project-details-drawer__field-card">
            <div class="project-details-drawer__field">
              <span class="project-details-drawer__label">UF</span>
              <span class="project-details-drawer__value">{{ property.state }}</span>
            </div>
          </div>

          <div class="project-details-drawer__field-card">
            <div class="project-details-drawer__field">
              <span class="project-details-drawer__label">Coordenadas</span>
              <span class="project-details-drawer__value">{{ property.coordinates }}</span>
            </div>
          </div>

          <div class="project-details-drawer__field-card">
            <div class="project-details-drawer__field">
              <span class="project-details-drawer__label">Hectares Totais</span>
              <span class="project-details-drawer__value">{{ property.totalHectares }}</span>
            </div>
          </div>

          <div class="project-details-drawer__field-card">
            <div class="project-details-drawer__field">
              <span class="project-details-drawer__label">Quantidade de redução de carbono</span>
              <span class="project-details-drawer__value">{{ property.carbonHectares }}</span>
            </div>
          </div>

          <div class="project-details-drawer__field-card">
            <div class="project-details-drawer__field">
              <span class="project-details-drawer__label">Bioma</span>
              <span class="project-details-drawer__value">{{ property.biome }}</span>
            </div>
          </div>

          <div class="project-details-drawer__field-card">
            <div class="project-details-drawer__field project-details-drawer__field--full">
              <span class="project-details-drawer__label">CAR</span>
              <span class="project-details-drawer__value">{{ property.car }}</span>
            </div>
          </div>
        </div>
      </div>

      <h2 class="project-details-drawer__section-title project-details-drawer__section-title--spaced">
        ETAPA 3 - METODOLOGIA
      </h2>

      <div class="project-details-drawer__field-card">
        <div class="project-details-drawer__field project-details-drawer__field--full">
          <span class="project-details-drawer__label">Metodologia</span>
          <span class="project-details-drawer__value">{{ methodologyLabel }}</span>
        </div>
      </div>

      <div class="project-details-drawer__field-card">
        <div class="project-details-drawer__field project-details-drawer__field--full">
          <span class="project-details-drawer__label">Link relatório</span>
          <a
            *ngIf="projectData.methodologyReportLink; else emptyReportLink"
            class="project-details-drawer__link"
            [href]="projectData.methodologyReportLink"
            target="_blank"
            rel="noopener noreferrer">
            {{ projectData.methodologyReportLink }}
            <b3-icon name="open_in_new" size="sm"></b3-icon>
          </a>
          <ng-template #emptyReportLink>
            <span class="project-details-drawer__value">-</span>
          </ng-template>
        </div>
      </div>

      <div class="project-details-drawer__field-card">
        <div class="project-details-drawer__field project-details-drawer__field--full">
          <span class="project-details-drawer__label">Descrição</span>
          <p class="project-details-drawer__value project-details-drawer__value--description">
            {{ projectData.methodologyDocumentDescription || '-' }}
          </p>
        </div>
      </div>

      <div class="project-details-drawer__field-card">
        <div class="project-details-drawer__field project-details-drawer__field--full">
          <span class="project-details-drawer__label">Documentos</span>
          <ng-container *ngIf="documentLinks.length; else emptyDocuments">
            <a
              *ngFor="let link of documentLinks"
              class="project-details-drawer__link project-details-drawer__document-link"
              [href]="link"
              target="_blank"
              rel="noopener noreferrer">
              {{ link }}
              <b3-icon name="open_in_new" size="sm"></b3-icon>
            </a>
          </ng-container>
          <ng-template #emptyDocuments>
            <span class="project-details-drawer__value">-</span>
          </ng-template>
        </div>
      </div>

      <h2 class="project-details-drawer__section-title project-details-drawer__section-title--spaced">
        ETAPA 4 - CO-BENEFÍCIOS
      </h2>

      <div class="project-details-drawer__field-card">
        <div class="project-details-drawer__field project-details-drawer__field--full">
          <span class="project-details-drawer__label">{{ selectedOdsCountLabel }}</span>
          <div class="project-details-drawer__ods-list" *ngIf="selectedOdsTags.length; else emptyOds">
            <b3-tag
              *ngFor="let odsTag of selectedOdsTags"
              class="project-details-drawer__ods-tag"
              size="sm"
              variant="filled"
              tone="neutral"
              [label]="odsTag">
            </b3-tag>
          </div>
          <ng-template #emptyOds>
            <span class="project-details-drawer__value">-</span>
          </ng-template>
        </div>
      </div>

      <div class="project-details-drawer__field-card">
        <div class="project-details-drawer__field project-details-drawer__field--full">
          <span class="project-details-drawer__label">Outros co-benefícios</span>
          <p class="project-details-drawer__value project-details-drawer__value--description">
            {{ projectData.coBenefits || '-' }}
          </p>
        </div>
      </div>

      <footer *ngIf="showAuditActions" class="project-details-drawer__footer">
        <div class="project-details-drawer__footer-actions">
          <b3-button
            class="project-details-drawer__footer-btn"
            type="button"
            variant="filled"
            tone="danger"
            (b3-click)="openRejectModal()">
            <b3-icon name="do_not_disturb_on" size="md" tone="on-brand"></b3-icon>
            Rejeitar
          </b3-button>
          <b3-button
            class="project-details-drawer__footer-btn"
            type="button"
            variant="filled"
            tone="default"
            (b3-click)="openApproveConfirmation()">
            <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
            Aprovar
          </b3-button>
        </div>
      </footer>
    </div>

    <ng-template #loadingState>
      <p class="project-details-drawer__loading">Carregando detalhes do projeto...</p>
    </ng-template>
  </b3-drawer-body>
</b3-drawer>

<app-project-validation-reject-modal
  [open]="showRejectStartModal"
  [projectName]="projectData?.projectName || ''"
  (closed)="onRejectStartModalClosed()"
  (confirmed)="onRejectFormConfirmed($event)">
</app-project-validation-reject-modal>

<app-project-validation-reject-confirm-modal
  [open]="showRejectConfirmModal"
  (closed)="onRejectConfirmModalClosed($event)">
</app-project-validation-reject-confirm-modal>

<app-project-validation-approve-modal
  [open]="showApproveModal"
  (closed)="onApproveModalClosed($event)">
</app-project-validation-approve-modal>
